import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { PromotionOutputDTO } from './promotionDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class PromotionServices {
  async getByAll(params: any): Promise<PromotionOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/promotion/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const promotionServices = new PromotionServices()
